import React from "react";

import "../css/loading.css";
const Loading = () => {
    return (
        <div className="loading">
            <h2><span role="img" aria-label="Loading">🔃</span> <i></i> Loading...</h2>
        </div>
    )
}

export default Loading
